import * as React from "react";
import { SVGProps } from "react";

const SvgEightHearts = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 247 346"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M237.2.3H9.6S0 .6 0 13.2v319.7c0 12.6 9.5 12.9 9.5 12.9h227.7s9.5-.3 9.5-12.9V13.2C246.8.5 237.2.3 237.2.3Z"
      fill="#fff"
    />
    <mask
      id="eight-hearts_svg__b"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={186}
      width={247}
      height={160}
    >
      <path
        d="M145.5 186.7H0v146.1c0 12.6 9.5 12.9 9.5 12.9h227.6s9.5-.3 9.5-12.9V186.7H145.5Z"
        fill="url(#eight-hearts_svg__a)"
      />
    </mask>
    <g mask="url(#eight-hearts_svg__b)">
      <path
        d="M145.5 186.7H0v146.1c0 12.6 9.5 12.9 9.5 12.9h227.6s9.5-.3 9.5-12.9V186.7H145.5Z"
        fill="url(#eight-hearts_svg__c)"
      />
    </g>
    <mask
      id="eight-hearts_svg__e"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={247}
      height={173}
    >
      <path
        d="M0 172.6H246.7V13.2C246.7.6 237.2.3 237.2.3H9.6S0 .6 0 13.2v159.4Z"
        fill="url(#eight-hearts_svg__d)"
      />
    </mask>
    <g mask="url(#eight-hearts_svg__e)">
      <path
        d="M0 172.6H246.7V13.2C246.7.6 237.2.3 237.2.3H9.6S0 .6 0 13.2v159.4Z"
        fill="url(#eight-hearts_svg__f)"
      />
    </g>
    <mask
      id="eight-hearts_svg__h"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={4}
      y={0}
      width={243}
      height={346}
    >
      <path
        d="M246.3 13.2v319.1c0 12.6-9.6 12.9-9.6 12.9H8.8s-2.1-.1-4.3-1.4c2.5 1.8 5 1.9 5 1.9h227.7s9.6-.3 9.6-12.9V13.2C246.8.6 237.2.3 237.2.3h-.5s9.6.2 9.6 12.9Z"
        fill="url(#eight-hearts_svg__g)"
      />
    </mask>
    <g mask="url(#eight-hearts_svg__h)">
      <path
        d="M246.3 13.2v319.1c0 12.6-9.6 12.9-9.6 12.9H8.8s-2.1-.1-4.3-1.4c2.5 1.8 5 1.9 5 1.9h227.7s9.6-.3 9.6-12.9V13.2C246.8.6 237.2.3 237.2.3h-.5s9.6.2 9.6 12.9Z"
        fill="url(#eight-hearts_svg__i)"
      />
    </g>
    <mask
      id="eight-hearts_svg__k"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={243}
      height={346}
    >
      <path
        d="M.5 332.8V13.7C.5 1.1 10.1.8 10.1.8H238s2.1.1 4.3 1.4c-2.5-1.8-5-1.9-5-1.9H9.6S0 .6 0 13.2v319.7c0 12.6 9.5 12.9 9.5 12.9h.5c.1-.1-9.5-.3-9.5-13Z"
        fill="url(#eight-hearts_svg__j)"
      />
    </mask>
    <g mask="url(#eight-hearts_svg__k)">
      <path
        d="M.5 332.8V13.7C.5 1.1 10.1.8 10.1.8H238s2.1.1 4.3 1.4c-2.5-1.8-5-1.9-5-1.9H9.6S0 .6 0 13.2v319.7c0 12.6 9.5 12.9 9.5 12.9h.5c.1-.1-9.5-.3-9.5-13Z"
        fill="url(#eight-hearts_svg__l)"
      />
      <mask
        id="eight-hearts_svg__n"
        style={{
          maskType: "alpha",
        }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={25}
        width={1}
        height={299}
      >
        <path
          d="M0 25.3v297.9c.2-.6.3-1.2.5-1.8V30.6C.3 28.9.2 27 0 25.3Z"
          fill="url(#eight-hearts_svg__m)"
        />
      </mask>
      <g mask="url(#eight-hearts_svg__n)">
        <path
          d="M0 25.3v297.9c.2-.6.3-1.2.5-1.8V30.6C.3 28.9.2 27 0 25.3Z"
          fill="url(#eight-hearts_svg__o)"
        />
      </g>
    </g>
    <path
      d="M26.6 67c-5.1 3.8-7.7 7.7-7.8 7.8-.1-.1-2.6-4.1-7.8-7.8-5.2-3.8-6.4-8.6-4.5-12.2 1.9-3.6 9.3-5.4 12.3 1.8 3-7.2 10.4-5.4 12.3-1.8 1.9 3.6.7 8.4-4.5 12.2ZM23.7 29.5v.3c1.6.6 2.9 1.6 3.7 2.8.8 1.2 1.3 2.7 1.3 4.4 0 1.7-.4 3.2-1.2 4.5-.8 1.3-2 2.3-3.5 3-1.5.7-3.4 1.1-5.4 1.1-1.9 0-3.6-.3-5.1-1-1.5-.6-2.6-1.6-3.4-2.8-.8-1.2-1.2-2.7-1.2-4.4 0-1.3.2-2.4.7-3.3.4-.9 1-1.7 1.7-2.3.7-.6 1.6-1.2 2.7-1.6v-.3c-3.1-1.4-4.7-3.7-4.7-7 0-1.5.4-2.8 1.2-4 .8-1.2 2-2.1 3.5-2.8 1.5-.7 3.2-1 5-1 2.1 0 3.9.3 5.3.9 1.4.6 2.5 1.4 3.2 2.6.7 1.1 1.1 2.4 1.1 4s-.4 3-1.2 4.1c-.8 1.1-2 2.1-3.7 2.8ZM13 37c0 .9.1 1.8.3 2.7.2.8.6 1.5 1 2.1.5.6 1.1 1.1 1.8 1.4.7.3 1.6.5 2.7.5 1.2 0 2.2-.2 3.1-.7.9-.5 1.5-1.2 1.9-2.2.4-1 .7-2.1.7-3.4 0-1.4-.2-2.6-.7-3.6-.5-1-1.2-1.8-2-2.3-.9-.5-1.9-.8-3-.8s-2 .2-2.7.5c-.7.3-1.3.8-1.8 1.4-.5.6-.8 1.2-1 2-.2.7-.3 1.5-.3 2.4Zm.3-14.3c0 .9.1 1.7.3 2.4.2.8.5 1.4 1 2 .5.6 1 1 1.8 1.3.7.3 1.6.5 2.7.5 1.2 0 2.2-.2 3-.7.8-.5 1.4-1.2 1.8-2.1.4-.9.6-2 .6-3.2 0-1.3-.2-2.4-.7-3.3-.5-.9-1.1-1.6-2-2-.8-.4-1.8-.7-2.9-.7-1.8 0-3.2.5-4.2 1.5-.9 1-1.4 2.5-1.4 4.3ZM219.6 278.4c5.1-3.8 7.7-7.7 7.8-7.8.1.1 2.6 4.1 7.8 7.8 5.2 3.8 6.4 8.6 4.5 12.2-1.9 3.6-9.3 5.4-12.3-1.8-3 7.2-10.4 5.4-12.3 1.8-1.9-3.6-.7-8.3 4.5-12.2ZM222.5 316v-.3c-1.6-.6-2.9-1.6-3.7-2.8-.8-1.2-1.3-2.7-1.3-4.4 0-1.7.4-3.2 1.2-4.5.8-1.3 2-2.3 3.5-3 1.5-.7 3.4-1.1 5.4-1.1 1.9 0 3.6.3 5.1 1 1.5.6 2.6 1.6 3.4 2.8.8 1.2 1.2 2.7 1.2 4.4 0 1.3-.2 2.4-.7 3.3-.4.9-1 1.7-1.7 2.3-.7.6-1.6 1.2-2.7 1.6v.3c3.1 1.4 4.7 3.7 4.7 7 0 1.5-.4 2.8-1.2 4-.8 1.2-2 2.1-3.5 2.8-1.5.7-3.2 1-5.1 1-2.1 0-3.9-.3-5.3-.9-1.4-.6-2.5-1.4-3.2-2.6-.7-1.1-1.1-2.4-1.1-4s.4-3 1.2-4.1c.9-1.2 2.2-2.1 3.8-2.8Zm10.7-7.5c0-.9-.1-1.8-.3-2.7-.2-.8-.6-1.5-1-2.1-.5-.6-1.1-1.1-1.8-1.4-.7-.3-1.6-.5-2.7-.5-1.2 0-2.2.2-3.1.7-.9.5-1.5 1.2-1.9 2.2-.4 1-.7 2.1-.7 3.4 0 1.4.2 2.6.7 3.6.5 1 1.2 1.8 2 2.3.9.5 1.9.8 3 .8s2-.2 2.7-.5c.7-.3 1.3-.8 1.8-1.4.5-.6.8-1.2 1-2 .2-.8.3-1.6.3-2.4Zm-.3 14.3c0-.9-.1-1.7-.3-2.4-.2-.8-.5-1.4-1-2-.5-.6-1-1-1.8-1.3-.7-.3-1.6-.5-2.7-.5-1.2 0-2.2.2-3 .7-.8.5-1.4 1.2-1.8 2.1-.4.9-.6 2-.6 3.2 0 1.3.2 2.4.7 3.3.5.9 1.1 1.6 2 2 .8.4 1.8.7 2.9.7 1.8 0 3.2-.5 4.2-1.5 1-1.1 1.4-2.5 1.4-4.3ZM93.2 81.9C83 89.4 78 97.2 77.8 97.4c-.1-.2-5.2-8-15.4-15.5-10.4-7.6-12.7-17.1-9-24.2 3.7-7.1 18.5-10.6 24.4 3.6 5.9-14.2 20.7-10.7 24.4-3.6 3.7 7.1 1.4 16.6-9 24.2ZM62.4 263.5c10.2-7.5 15.3-15.3 15.4-15.5.1.2 5.2 8 15.4 15.5 10.4 7.6 12.7 17.1 9 24.2-3.7 7.2-18.5 10.6-24.4-3.6-5.9 14.2-20.7 10.7-24.4 3.6-3.7-7.2-1.3-16.7 9-24.2ZM184.3 81.9c-10.2 7.5-15.3 15.3-15.4 15.5-.1-.2-5.2-8-15.4-15.5-10.4-7.6-12.7-17.1-9-24.2 3.7-7.1 18.5-10.6 24.4 3.6 5.9-14.2 20.7-10.7 24.4-3.6 3.7 7.1 1.4 16.6-9 24.2ZM93.2 180.1C83 187.6 78 195.4 77.8 195.7c-.1-.2-5.2-8-15.4-15.5-10.4-7.6-12.7-17.1-9-24.2 3.7-7.2 18.5-10.6 24.4 3.6 5.9-14.2 20.7-10.7 24.4-3.6 3.7 7 1.4 16.5-9 24.1ZM184.3 180.1c-10.2 7.5-15.3 15.3-15.4 15.5-.1-.2-5.2-8-15.4-15.5-10.4-7.6-12.7-17.1-9-24.2 3.7-7.2 18.5-10.6 24.4 3.6 5.9-14.2 20.7-10.7 24.4-3.6 3.7 7.1 1.4 16.6-9 24.2ZM153.5 263.5c10.2-7.5 15.3-15.3 15.4-15.5.1.2 5.2 8 15.4 15.5 10.4 7.6 12.7 17.1 9 24.2-3.7 7.2-18.5 10.6-24.4-3.6-5.9 14.2-20.7 10.7-24.4 3.6-3.7-7.2-1.3-16.7 9-24.2ZM138.8 132.2c-10.2 7.5-15.3 15.3-15.4 15.5-.1-.2-5.2-8-15.4-15.5-10.4-7.6-12.7-17.1-9-24.2 3.7-7.2 18.5-10.6 24.4 3.6 5.9-14.2 20.7-10.7 24.4-3.6 3.7 7.2 1.3 16.6-9 24.2ZM138.8 218.6c-10.2-7.5-15.3-15.3-15.4-15.5-.1.2-5.2 8-15.4 15.5-10.4 7.6-12.7 17.1-9 24.2 3.7 7.1 18.5 10.6 24.4-3.6 5.9 14.2 20.7 10.7 24.4 3.6 3.7-7.1 1.3-16.6-9-24.2Z"
      fill="#FF2601"
    />
    <defs>
      <radialGradient
        id="eight-hearts_svg__a"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(119.562 -117.476) scale(499.517)"
      >
        <stop offset={0.616} />
        <stop offset={0.752} stopColor="#020202" />
        <stop offset={0.804} stopColor="#090909" />
        <stop offset={0.841} stopColor="#151515" />
        <stop offset={0.872} stopColor="#262626" />
        <stop offset={0.899} stopColor="#3C3C3C" />
        <stop offset={0.922} stopColor="#585858" />
        <stop offset={0.944} stopColor="#797979" />
        <stop offset={0.963} stopColor="#9F9F9F" />
        <stop offset={0.982} stopColor="#CBCBCB" />
        <stop offset={0.998} stopColor="#F9F9F9" />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="eight-hearts_svg__c"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(119.562 -117.476) scale(499.517)"
      >
        <stop offset={0.616} stopColor="#fff" />
        <stop offset={0.788} stopColor="#FDFDFD" />
        <stop offset={0.854} stopColor="#F6F6F6" />
        <stop offset={0.901} stopColor="#EAEAEA" />
        <stop offset={0.94} stopColor="#D9D9D9" />
        <stop offset={0.974} stopColor="#C3C3C3" />
        <stop offset={1} stopColor="#ABABAB" />
      </radialGradient>
      <radialGradient
        id="eight-hearts_svg__d"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(124.504 319.065) scale(357.936)"
      >
        <stop offset={0.616} />
        <stop offset={0.71} stopColor="#020202" />
        <stop offset={0.762} stopColor="#0A0A0A" />
        <stop offset={0.805} stopColor="#181818" />
        <stop offset={0.842} stopColor="#2C2C2C" />
        <stop offset={0.875} stopColor="#464646" />
        <stop offset={0.906} stopColor="#656565" />
        <stop offset={0.935} stopColor="#8A8A8A" />
        <stop offset={0.963} stopColor="#B6B6B6" />
        <stop offset={0.988} stopColor="#E5E5E5" />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="eight-hearts_svg__f"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(124.504 319.065) scale(357.936)"
      >
        <stop offset={0.616} stopColor="#fff" />
        <stop offset={0.747} stopColor="#FDFDFD" />
        <stop offset={0.821} stopColor="#F5F5F5" />
        <stop offset={0.88} stopColor="#E7E7E7" />
        <stop offset={0.932} stopColor="#D3D3D3" />
        <stop offset={0.978} stopColor="#BABABA" />
        <stop offset={1} stopColor="#ABABAB" />
      </radialGradient>
      <radialGradient
        id="eight-hearts_svg__g"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(-10.547 .134) scale(397.434)"
      >
        <stop offset={0.099} />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="eight-hearts_svg__i"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(-10.547 .134) scale(397.434)"
      >
        <stop offset={0.099} stopColor="#fff" />
        <stop offset={1} stopColor="#ABABAB" />
      </radialGradient>
      <radialGradient
        id="eight-hearts_svg__j"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(67.406 100.823) scale(338.508)"
      >
        <stop />
        <stop offset={0.007} stopColor="#090909" />
        <stop offset={0.048} stopColor="#373737" />
        <stop offset={0.093} stopColor="#626262" />
        <stop offset={0.142} stopColor="#888" />
        <stop offset={0.195} stopColor="#A8A8A8" />
        <stop offset={0.254} stopColor="#C4C4C4" />
        <stop offset={0.32} stopColor="#DADADA" />
        <stop offset={0.397} stopColor="#EBEBEB" />
        <stop offset={0.493} stopColor="#F6F6F6" />
        <stop offset={0.627} stopColor="#FDFDFD" />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="eight-hearts_svg__l"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(67.406 100.823) scale(338.508)"
      >
        <stop stopColor="#fff" />
        <stop offset={0.141} stopColor="#fff" />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="eight-hearts_svg__m"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(180 128.605 .066) scale(397.383)"
      >
        <stop offset={0.099} />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="eight-hearts_svg__o"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(180 128.605 .066) scale(397.383)"
      >
        <stop offset={0.099} stopColor="#fff" />
        <stop offset={1} stopColor="#ABABAB" />
      </radialGradient>
    </defs>
  </svg>
);

export default SvgEightHearts;
